import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "video-form",
  templateUrl: "./video-form.component.html",
  styleUrls: ["./video-form.component.scss"],
})
export class VideoFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/components/video-form/video-form.component.ts